(function () {
  var EU_COUNTRY_CODES = [
    "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
    "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK",
    "SI", "ES", "SE"
  ];
  var LINK_SELECTOR = "[data-eu-only-footer-link]";

  function isEuCountry(countryCode) {
    if (!countryCode) return false;
    return EU_COUNTRY_CODES.indexOf(String(countryCode).toUpperCase()) !== -1;
  }

  function setLinksVisible(visible) {
    var links = document.querySelectorAll(LINK_SELECTOR);

    links.forEach(function (link) {
      link.hidden = !visible;
    });
  }

  function getShopifyCountry() {
    return window.Shopify && window.Shopify.country;
  }

  function getTraceCountry(traceText) {
    var match = String(traceText || "").match(/^loc=([A-Z]{2})$/m);
    return match ? match[1] : null;
  }

  function updateFromTrace() {
    if (!window.fetch) {
      setLinksVisible(isEuCountry(getShopifyCountry()));
      return;
    }

    window.fetch("/cdn-cgi/trace", {
      cache: "no-store",
      credentials: "same-origin"
    })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(function (traceText) {
        var traceCountry = getTraceCountry(traceText);
        var shopifyCountry = getShopifyCountry();

        if (traceCountry || shopifyCountry) {
          setLinksVisible(isEuCountry(traceCountry) || isEuCountry(shopifyCountry));
          return;
        }

        setLinksVisible(false);
      })
      .catch(function () {
        setLinksVisible(isEuCountry(getShopifyCountry()));
      });
  }

  function init() {
    setLinksVisible(false);
    updateFromTrace();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
